import { Company, CompanyUser } from "../models";
import { fetchAuthenticated } from "../scripts/custom-fetch";

// Without all, returns only the companies the current user belongs to
export async function getCompanies(all = false) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/companies${all ? "?scope=all" : ""}`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as Company[];
}

export async function createCompany(company: Pick<Company, "name">) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/companies`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(company),
  });

  if (!response.ok) {
    const body = await response.json();
    throw new Error(body?.errors?.[0]?.msg ?? "Something went wrong");
  }

  return await response.json() as Company;
}

export async function updateCompany(companyId: number, company: Partial<Pick<Company, "name" | "status">>) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/companies/${companyId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(company),
  });

  if (!response.ok) {
    const body = await response.json();
    throw new Error(body?.errors?.[0]?.msg ?? "Something went wrong");
  }

  return await response.json() as Company;
}

export async function getCompanyUsers(companyId: number) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/companies/${companyId}/users`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as CompanyUser[];
}

export async function setCompanyUsers(companyId: number, userIds: number[]) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/companies/${companyId}/users`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ userIds }),
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as CompanyUser[];
}

// Enabled user accounts, for choosing company members
export async function getUsers() {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/admin/getUsers`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as CompanyUser[];
}
